import { supabase } from '../supabase';
import { recordOpportunityActivity } from '../opportunityActivities';
import { triggerEnterStageAutomations } from '../automationsV2';

/**
 * Moves an opportunity to a different pipeline stage and mirrors the side
 * effects of the CRM board move (Enter-Stage automations + activity log) so
 * the message-conversation Lead banner stays in sync with the CRM.
 *
 * The DB update is awaited; automations are fired-and-forgotten (matching the
 * CRM board) and the activity log is best-effort.
 */
export async function moveOpportunityToStage(params: {
  businessId: string;
  opportunityId: number;
  customerId?: string | null;
  oldStageId: number;
  newStageId: number;
  oldStageName?: string | null;
  newStageName?: string | null;
}): Promise<void> {
  const {
    businessId,
    opportunityId,
    customerId,
    oldStageId,
    newStageId,
    oldStageName = null,
    newStageName = null,
  } = params;

  if (!supabase || !businessId || !opportunityId) {
    throw new Error('moveOpportunityToStage: missing required parameters');
  }
  if (oldStageId === newStageId) return;

  const { error } = await supabase
    .from('pipeline_opportunities')
    .update({ stage_id: newStageId })
    .eq('id', opportunityId);
  if (error) throw error;

  void triggerEnterStageAutomations(businessId, opportunityId, {
    previousStageId: oldStageId,
    previousStageName: oldStageName,
  });

  if (customerId) {
    recordOpportunityActivity({
      businessId,
      customerId,
      activityType: 'stage_moved',
      activityData: {
        old_stage_id: oldStageId,
        new_stage_id: newStageId,
        old_stage_name: oldStageName,
        new_stage_name: newStageName,
      },
      specificOpportunityId: opportunityId,
    }).catch((err) => {
      console.error('[moveOpportunityToStage] Error recording activity:', err);
    });
  }
}
